import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import isMobileAppRuntime, { getMobileAppPlatform } from 'utils/isMobileAppRuntime';

const safeHost = (value) => {
  try {
    return new URL(value, window.location.origin).host;
  } catch (error) {
    return String(value || 'unknown');
  }
};

const MobileRuntimeDebug = () => {
  const common = useSelector((state) => state.common);
  const learner = useSelector((state) => state.flinkPlay?.learner);
  const learningCenter = useSelector((state) => state.flinkPlay?.learningCenter);

  const text = useMemo(() => {
    const mobileWrapper = common?.config?.customContentSettings?.mobileWrapper || {};
    const configuredLearningCenterId = String(mobileWrapper.learningCenterId || '');
    const currentLearningCenterId = String(
      learningCenter?._id || learner?.learningCenterId || configuredLearningCenterId || ''
    );
    const selectedLearningCenter = (common?.learningCenters || []).find(
      (item) => String(item?._id) === currentLearningCenterId
    );

    return [
      getMobileAppPlatform().toUpperCase(),
      safeHost(window.location.href),
      selectedLearningCenter?.name || currentLearningCenterId || 'LC not resolved',
    ].join(' · ');
  }, [common, learner, learningCenter]);

  const debugEnabled = new URLSearchParams(window.location.search).get('flcMobileDebug') === '1'
    || window.localStorage.getItem('flcMobileDebug') === '1';

  if (!isMobileAppRuntime() || !debugEnabled) return null;

  return <DebugLabel aria-label="Mobile runtime debug destination">{text}</DebugLabel>;
};

export default MobileRuntimeDebug;

const DebugLabel = styled.div`
  position: fixed;
  right: max(5px, env(safe-area-inset-right));
  bottom: max(4px, env(safe-area-inset-bottom));
  z-index: 5000;
  max-width: calc(100vw - 18px);
  padding: 2px 5px;
  border-radius: 4px;
  color: rgba(29, 51, 86, .52);
  background: rgba(255, 255, 255, .45);
  font-size: 6px;
  line-height: 1.15;
  font-weight: 500;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
`;
